
import { VariantProps } from "@stitches/react";
import { keyframes, styled } from "../../../theme.stitches";
import { motion } from 'framer-motion'

export type ButtonVariants = VariantProps<typeof Button>;

const underlineAnimation = keyframes({
    "0%": {
        transform: "translateX(0)"
    },
    "50%": {
        transform: "translateX(100%)"
    },
    "100%": {
        transform: "translateX(0)"
    }
})

const Button = styled(motion.button, {
    appearance: 'none',
    userSelect: 'none',
    flexShrink: '0',
    outline: 'none',
    cursor: 'pointer',
    border: 'none',

    width: 'max-content',
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    fontFamily: 'Museo Sans',  
    fontSize: "$paragraph",
    fontWeight: "600",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: '$paragraph',
    color: "$white",
    padding: '0.6875rem 1.5rem',
    transition: "backgroundColor 0.2s ease-in-out",

    '@mobile': {
        width: '100% !important',
        margin: '1rem 0',
    },

    '&:hover': {
        backgroundColor: '$black'
    },

    ['svg']: {
        marginLeft: '.625rem'
    },

    ['&:focus']: {
    },

    ['&:disabled']: {
        backgroundColor: '$grey2',
        cursor: 'not-allowed',

        '&:hover': {
            backgroundColor: '$grey1'
        }
    },

    variants: {
        style: {
            default: {
                color: 'white',
                fontSize: '$paragraph',
                fontWeight: '400',
                padding: '0.5rem 1rem',
                backgroundColor: '$primary',
                borderRadius: '.5rem',
                boxShadow: '0px 3px 0px 0px #2183A4',

                '&:hover': {
                    backgroundColor: '#1D85A8',
                    borderRadius: '.5rem',
                }
            },
            white: {
                color: '$grey9',
                fontSize: '$paragraph',
                fontWeight: '700',
                padding: '0.5rem 1rem',
                backgroundColor: '$white',
                borderRadius: '.5rem',
                boxShadow: '0px 3px 0px 0px #CCCCCC',
                textDecoration: 'none',


                '&:hover': {
                    backgroundColor: '#CCCCCC',
                    borderRadius: '.5rem',
                }
            },
            anchor: {
                textDecoration: 'none',
                color: 'white',
                fontSize: '$paragraph',
                fontWeight: '700',
                padding: '0.75rem .5rem',
                backgroundColor: '$primary',
                borderRadius: '.125rem',
                boxShadow: 'inset 0px 0px 0px 1px rgba(0,0,0,.2)',
                'a': {
                    textDecoration: 'none',
                },

                '&:hover': {
                    backgroundColor: '#1D85A8',
                    borderRadius: '.5rem',
                }
            },

        },
    },
    defaultVariants: {
        style: 'default'
    }
});

export default Button;